import { Typography } from '@mui/material';
import React from 'react';

const Payment = () => {
    return (
        <div style={{height:'70vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
            <Typography variant="h4" gutterBottom component="div">
            Payment system is comming soon !

           </Typography>
            
            
        </div>
    );
};

export default Payment;